import classNames from 'classnames';
import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';
import { rating as ratingTranslation } from '@/core/tamagoshiTailwind/translations';
import type { RichTextFormatter } from '@/domains/core/localization/translate';
import { Rating as TamagoshiRating } from '@/domains/core/tamagoshiTailwind/components/Rating/Rating';
import { H2 } from '@/domains/core/tamagoshiv2/components/Typography/Typography';
import { RatingBars } from '@/domains/productDiscovery/ArticleReviews/components/RatingBars/RatingBars';
import { useReviewsStats } from '@/domains/productDiscovery/ArticleReviews/ReviewsStats.ducks';
import { reviewsBlockTitle, reviewsOneGlobalRating, reviewsOtherGlobalRating } from '@/domains/productDiscovery/ArticleReviews/translations';
import styles from './reviewsStats.module.scss';

// todo: use proper translator with quantity
const strongFormatter: RichTextFormatter = chunks => <b key="strong-formatter">{chunks}</b>;
export const ReviewsStats = ({
  hideTitle = false,
  className
}: {
  hideTitle?: boolean;
  className?: string;
}) => {
  const {
    fetched,
    average,
    total,
    distribution
  } = useReviewsStats();
  if (fetched && average === 0) return null;
  if (!fetched) return <Skeleton width="100%" height="145px" />;
  const rating = average.toFixed(1).replace('.', ',');
  return <>
      {!hideTitle && <H2 className={styles.textTitle}>{reviewsBlockTitle}</H2>}
      <div className={classNames(className, styles.statsContainer)}>
        <div className={styles.rateContainer}>
          <div className={styles.rate} aria-label={rating}>
            {`${rating}/5`}
          </div>
          <TamagoshiRating aria-label={ratingTranslation.ariaLabel} size="M" value={average} />
          <div className={styles.ratingText}>
            {total === 1 ? reviewsOneGlobalRating.format({
            total,
            strong: strongFormatter
          }) : reviewsOtherGlobalRating.format({
            total,
            strong: strongFormatter
          })}
          </div>
        </div>
        <RatingBars distribution={distribution} />
      </div>
    </>;
};
ReviewsStats.displayName = 'ReviewsStats';